<script lang="ts">
	import { browser } from '$app/environment';
	import getClientWidth from 'utils/getClientWidth';
	import { onMount } from 'svelte';
	import { _ } from 'utils/i18/i18n';

	type EmptyTableTypes =
		| 'coin-list'
		| 'exchanges'
		| 'coin-markets'
		| 'watchlist'
		| 'portfolio'
		| 'holders'
		| 'exchange-top-markets'
		| 'financial-reserves'
		| 'exchange-markets';

	export let dark = false;
	export let colAmountMobView: number;
	export let colAmountFromTabletView: number;
	export let rows = 5;
	export let tableType: EmptyTableTypes;
	export let withNoDataText = false;
	export let withLoadingText = false;
	let buildingArrays = { columns: [], rows: [] };
	let viewportWidth: number;
	let isMobileView = false;

	onMount(() => {
		if (!browser) return;
		viewportWidth = getClientWidth();
		createArrayForIteration();
		window.addEventListener('resize', calculateViewportWidth);
		return () => {
			window.removeEventListener('resize', calculateViewportWidth);
		};
	});

	function calculateViewportWidth() {
		viewportWidth = getClientWidth();
		isMobileView = viewportWidth < 768;
	}

	function createArrayForIteration() {
		buildingArrays.columns = [
			...Array(isMobileView ? colAmountMobView : colAmountFromTabletView).fill(''),
		];
		buildingArrays.rows = [...Array(rows).fill('')];
	}

	$: isMobileView, createArrayForIteration();
</script>

<div class="empty" class:dark>
	{#each buildingArrays.rows as row}
		<tr class={`empty-row ${tableType}`}>
			{#each buildingArrays.columns as column}
				<td class={`empty-cell ${tableType}`}>
					<p class="empty-text" />
				</td>
			{/each}
		</tr>
	{/each}
	{#if withNoDataText || withLoadingText}
		<p class="no-data" class:dark>
			{withLoadingText ? '' : $_('general.noDataAvailable')}
		</p>
	{/if}
</div>

<style lang="scss">
	@import 'emptyTable';
</style>
